<template>
    <AppMainDialogForm v-model="dialog" :isLoading="isLoading" size='650' :tituloTela="tituloTela" :tooltip="tooltip" 
        @initComponent="initComponent" @saveRegistro="saveRegistro" @cancel="cancel" :canDelete="isEditing" @deleteRegistro="deleteRegistro">
        <v-form v-model="isFormValid" ref="form" name="form">
            <v-layout row justify-center>
                <v-flex class="item" xs5 md5>
                    <v-text-field :rules="[campoObrigatorio, campoMaiorZero]" type="tel" v-model.number="registro.nrDia" v-mask="maskNumber"
                        :label="labelItem" outlined clearable> </v-text-field>
                </v-flex>
                <v-flex class="item" xs6 md6>
                    <v-text-field :rules="[campoObrigatorio, campoMaiorZero, isAValidFloat]" type="tel" v-model.number="registro.valor" 
                        :label="labelValor" outlined clearable> </v-text-field>
                </v-flex>
            </v-layout>
        </v-form>
    </AppMainDialogForm>
</template>

<script>
    import { campoObrigatorio, isAValidFloat, campoMaiorZero } from '@/filters/rules'
    import { mask } from 'vue-the-mask'

    import AppMainDialogForm from '@/components/layout/AppMainDialogForm.vue'

    export default {
        components: {
            AppMainDialogForm,
        },
        directives: {
            mask,
        },
        data () {
            return {
                tooltip: 'Informar Ponto da Tabela',
                tituloTela: 'Informar Ponto da Tabela',
                isFormValid: false,
                isLoading: false,
                registro: {},
                isInserting: false,
                isEditing: false,
                maskNumber: '####',
            }
        },
        methods: {
            campoObrigatorio,
            isAValidFloat,
            campoMaiorZero,
            initComponent() {
                if (this.rec.idTabelaPontos != undefined)
                {
                    this.isEditing = true
                    this.isInserting = false
                    this.registro.nrDia = this.rec.nrDia
                    this.registro.valor = parseFloat(this.rec.valor).toFixed(3)
                }
                else
                {
                    this.isInserting = true
                    this.isEditing = false
                    this.registro = {}
                    if (this.$refs.form != undefined)
                        this.$refs.form.reset()
                }
                this.$emit('openDialog')
            },
            saveRegistro() {
                if (this.$refs.form.validate())
                {
                    var record = {
                        idTabelaPontos: this.rec.idTabelaPontos != undefined ? parseInt(this.rec.idTabelaPontos) : null,
                        nrDia: parseInt(this.registro.nrDia),
                        valor: parseFloat(this.registro.valor).toFixed(3)
                    }
                    
                    this.$emit('saved', record)
                    this.$emit('closeDialog')
                }
            },
            deleteRegistro() {
                var record = {
                    idTabelaPontos: this.rec.idTabelaPontos != undefined ? parseInt(this.rec.idTabelaPontos) : null,
                    nrDia: parseInt(this.registro.nrDia),
                    valor: parseFloat(this.registro.valor).toFixed(3)
                }
                this.$emit('deleted', record)
            },
            cancel() {
                this.$emit('closeDialog')
            }
        },
        props: {
            dialog: {
                type: Boolean,
                default: false
            },
            rec: Object,
            labelValor: {
                type: String,
                default: ''
            },
            labelItem: {
                type: String,
                default: ''
            },
        },
        watch: {
            'dialog' (newValue, oldValue) {
                if (newValue && !oldValue)
                {
                    this.initComponent()
                }
            }
        }
    }
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
